import { Component, Prop, h } from '@stencil/core';
import Icon from '../svg/check.svg'
@Component({
  tag: 'cr-icon-check',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconCheck {
  /**
    * The size of the icon - can be 'small', 'medium' or 'large'
    */
  @Prop() size: string
  @Prop() disabled: boolean
  render() {
    return (
      <div
        part='cr-icon'
        class={`${this.size} ${this.disabled ? 'disabled' : ''}`}
        innerHTML={Icon}
      />
    );
  }

}
